import { Box, keyframes } from '@chakra-ui/react';
import type { ReactNode } from 'react';

const gradientShift = keyframes`
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
`;

export const AnimatedGradientBox = ({
  children,
  active = false,
}: {
  children: ReactNode;
  active?: boolean;
}) => {
  if (!active) {
    return children;
  }

  return (
    <Box
      bgGradient="linear(to-r, #F1F5F933, #6AAEFF33, #6CF2F233, #9AF2A833)"
      backgroundSize="400% 400%"
      animation={`${gradientShift} 8s ease infinite`}
    >
      {children}
    </Box>
  );
};
